import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { IntlUnitFormattingService } from '../../services/intl-unit-formatting-services/intl-unit-formatting-service';

/**
 * @param {object} props
 * @param {import('../../prop-types/weight-types').WeightValue | null}  props.weight - The weight value to format. If null, it indicates that the weight is unavailable or not provided.
 * @returns {JSX.Element | string | undefined} A formatted weight string based on the provided weight and the seller's default weight unit.
 */
export const FormattedWeight = ({ weight }) => {
  const sellerDefaultWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  return IntlUnitFormattingService.formatWeight(weight, sellerDefaultWeightUnit);
};
